module.exports = __webpack_public_path__ + "static/media/fineartImage.37652539.jpg";